import { SMART_FILTER_DEFAULTS } from '../../types/electionSim'
import type { SimRunResponse, Targeting } from '../../types/electionSim'

/**
 * Pure smart-target preset fills (P2). Each returns a fresh `Targeting` the caller hands to the
 * lever-panel `onChange` — no resolution logic, just a shape the existing engine already handles.
 */

/** "GOTV sweet spot": mid-propensity movable band + your-side lean (the combination that flips net positive). */
export function gotvSweetSpotTargeting(): Targeting {
  return { kind: 'smartfilter', smartFilter: SMART_FILTER_DEFAULTS }
}

/** GeoUnit ids of precincts whose marginal net (sensitivity value) is strictly positive in this run. */
export function positiveNetPrecinctIds(run: SimRunResponse | null): string[] {
  return (run?.unitSensitivities ?? []).filter((s) => s.value > 0).map((s) => s.geoUnitId)
}

/** "Where effort helps": target exactly the positive-net precincts from the last run. */
export function whereEffortHelpsTargeting(precinctGeoUnitIds: string[]): Targeting {
  return { kind: 'precincts', precinctGeoUnitIds }
}
